"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var mapBrandInfo = function mapBrandInfo(response) {
  if (!response) return false;
  var svgLogo = "";
  var description = [];
  response.data.body.forEach(function (data) {
    if (data.slice_type === "brandlogo") {
      var _data$primary;
      (_data$primary = data.primary) === null || _data$primary === void 0 ? void 0 : _data$primary.svglogo.forEach(function (logoPart) {
        return svgLogo += logoPart.text;
      });
    }
    if (data.slice_type === "text") {
      description.push(data.primary.text[0]);
    }
  });
  return {
    title: response.data.title[0].text,
    description: description,
    logo: svgLogo.replace('"', '"')
  };
};
var _default = mapBrandInfo;
exports["default"] = _default;